export const cleanPercentage = (percentage) => {
    const isNegativeOrNaN = !Number.isFinite(+percentage) || percentage < 0;
    const isTooHigh = percentage > 100;
    
    return isNegativeOrNaN ? 0 : isTooHigh ? 100 : +percentage;
};